import HelpText from './HelpText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

function SectionHeader({
    title,
    buttonText = undefined,
    buttonCallback = undefined,
    buttonIcon = faPlus,
    buttonTitle = undefined,
    disabled = false,
}) {
    return (
        <div
            className='page-header'
            role='banner'
        >
            <h1>{title}</h1>
            <div className='primary-actions'>
                {buttonText && (
                    <button
                        className='hollow'
                        onClick={buttonCallback}
                        disabled={disabled}
                        style={{ padding: '10px 20px' }}
                        title={buttonTitle}
                    >
                        <FontAwesomeIcon icon={buttonIcon} /> {buttonText}
                    </button>
                )}
                <HelpText />
            </div>
        </div>
    );
}

export default SectionHeader;
